import { Stack, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FaxIcon } from 'assets/icons/FaxIcon';
import styles from './NoFaxesOverlay.module.scss';

type Props = {
  title?: string;
  actionLabel?: string;
  onSendFaxClick(): void;
};

export function NoFaxesOverlay({ title, actionLabel, onSendFaxClick }: Props) {
  const { t } = useTranslation('settings');
  const resolvedTitle = title ?? t('faxCommon.yourReceivedFolderIsEmpty');
  const resolvedActionLabel = actionLabel ?? t('faxCommon.sendFax');

  return (
    <div className={styles.container}>
      <Stack spacing={2} alignItems='center'>
        <FaxIcon sx={{ fontSize: 72, color: 'text.primary' }} />

        <Typography variant='h6' sx={{ fontWeight: 500 }}>
          {resolvedTitle}
        </Typography>

        <Button variant='contained' onClick={onSendFaxClick} sx={{ px: 4, fontWeight: 600 }}>
          {resolvedActionLabel}
        </Button>
      </Stack>
    </div>
  );
}
